import { Flex, Spinner } from '@chakra-ui/react';

const Loader = () => (
    <Flex height="250px" alignItems="center" justifyContent="center">
        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="brand.500" size="xl" />
    </Flex>
);

export default Loader;
